import { module as BaseModule } from 'modujs';

// Usamos GSAP desde CDN
const g = (typeof window !== 'undefined' && window.gsap) ? window.gsap : null;

// Registramos plugins si están disponibles
if (g) {
	if (typeof window !== 'undefined' && window.DrawSVGPlugin && !g.plugins.DrawSVGPlugin) {
		g.registerPlugin(window.DrawSVGPlugin);
	}
	if (typeof window !== 'undefined' && window.ScrollTrigger && !g.plugins.ScrollTrigger) {
		g.registerPlugin(window.ScrollTrigger);
	}
}

export default class extends BaseModule {
	constructor(m) {
		super(m);
		this._tl = null;
		this._st = null;
		this._hasAnimated = false;
	}

	init() {
		if (!g) {
			console.error('%cFIRMA ERROR: GSAP no cargado en window.gsap', 'color: #f00; font-weight: bold;');
			return;
		}

		console.log('%c=== FIRMA INIT START ===', 'color: #0a8; font-weight: bold;');
		console.log(`%cGSAP disponible: ${!!g}`, 'color: #0a8;');
		console.log(`%cDrawSVGPlugin disponible: ${!!window.DrawSVGPlugin}`, 'color: #0a8;');
		console.log(`%cDrawSVGPlugin en plugins: ${!!g.plugins?.DrawSVGPlugin}`, 'color: #0a8;');

		const item = this.el;
		const svg = item.querySelector('svg');
		if (!svg) {
			console.error('%cFIRMA ERROR: SVG no encontrado', 'color: #f00; font-weight: bold;');
			return;
		}

		// Obtener todos los paths
		const paths = svg.querySelectorAll('path');
		if (!paths.length) {
			console.error('%cFIRMA ERROR: No paths encontrados', 'color: #f00; font-weight: bold;');
			return;
		}

		console.log(`%cFIRMA: ${paths.length} paths detectados`, 'color: #0a8; font-size: 14px; font-weight: bold;');

		// Duración total configurable
		const baseDuration = parseFloat(item.dataset.duration) || 3;
		console.log(`%cDuración: ${baseDuration}s`, 'color: #0a8;');

		// Preparar paths: convertir fill paths a stroke paths para DrawSVG
		paths.forEach((path, idx) => {
			const fill = path.getAttribute('fill') || '#222222';
			const isFilled = fill !== 'none';

			if (isFilled) {
				// Convertir filled path a stroked path
				path.setAttribute('stroke', fill);
				path.setAttribute('stroke-width', '2');
				path.setAttribute('fill', 'none');
				path.setAttribute('stroke-linecap', 'round');
				path.setAttribute('stroke-linejoin', 'round');
				console.log(`%c  Path ${idx}: CONVERTIDO a stroke (fill era ${fill})`, 'color: #0a8;');
			}

			// Calcular longitud del path
			try {
				const len = path.getTotalLength();
				path.dataset.pathLength = len;
				console.log(`%c  Path ${idx}: longitud = ${len.toFixed(0)}`, 'color: #0a8;');
			} catch (e) {
				console.error(`%c  Path ${idx}: ERROR calculando longitud:`, e, 'color: #f00;');
			}
		});

		// Crear timeline
		const tl = g.timeline({ paused: true });
		this._tl = tl;

		const hasDrawSVG = !!g.plugins?.DrawSVGPlugin;
		console.log(`%cUsando: ${hasDrawSVG ? 'DrawSVG' : 'strokeDashoffset (fallback)'}`, `color: ${hasDrawSVG ? '#0a8' : '#a80'}; font-weight: bold;`);

		// Animar cada path EN PARALELO (todos comienzan a la vez)
		paths.forEach((path, idx) => {
			const len = parseFloat(path.dataset.pathLength) || 100;

			// Usar DrawSVG si está disponible
			if (hasDrawSVG) {
				// DrawSVG: animar desde 0% (sin dibujar) a 100% (completamente dibujado)
				tl.fromTo(
					path,
					{ drawSVG: '0%' },
					{
						drawSVG: '100%',
						duration: baseDuration,
						ease: 'power1.inOut'
					},
					0 // 0 = añadir en paralelo (tiempo 0)
				);
			} else {
				// Fallback: stroke-dasharray y strokeDashoffset
				
				// Configurar dasharray = longitud total (oculta toda la línea)
				path.setAttribute('stroke-dasharray', len);
				path.setAttribute('stroke-dashoffset', len);
				
				console.log(`%c  Path ${idx}: stroke-dasharray=${len}, stroke-dashoffset=${len}`, 'color: #a80;');
				
				// Animar de offset = len (invisible) a offset = 0 (visible)
				tl.fromTo(
					path,
					{ strokeDashoffset: len },
					{
						strokeDashoffset: 0,
						duration: baseDuration,
						ease: 'power1.inOut'
					},
					0 // 0 = añadir en paralelo
				);
			}
		});

		console.log(`%cFIRMA: Timeline creada, duración = ${tl.duration().toFixed(2)}s`, 'color: #0a8; font-weight: bold;');

		// Disparar animación
		const triggerAnimation = () => {
			if (this._hasAnimated) {
				console.log('%cFIRMA: Ya animada, ignorando trigger', 'color: #a80;');
				return;
			}
			this._hasAnimated = true;
			console.log('%cFIRMA: ▶️ INICIANDO ANIMACIÓN', 'color: #0a8; font-size: 16px; font-weight: bold;');
			tl.play();
		};

		// ScrollTrigger
		if (g.plugins.ScrollTrigger) {
			console.log('%cFIRMA: ScrollTrigger activado', 'color: #0a8;');
			const st = g.plugins.ScrollTrigger.create({
				trigger: item,
				start: 'top 80%',
				onEnter: () => {
					console.log('%cFIRMA: ScrollTrigger ENTER', 'color: #0a8;');
					triggerAnimation();
					st.kill();
				}
			});
			this._st = st;
		} else {
			console.warn('%cFIRMA WARNING: ScrollTrigger no disponible, animando en 100ms', 'color: #a80;');
			// Animar inmediatamente
			setTimeout(() => triggerAnimation(), 100);
		}
		console.log('%c=== FIRMA INIT END ===', 'color: #0a8; font-weight: bold;');
	}

	destroy() {
		if (this._tl) {
			try { this._tl.kill(); } catch (e) { }
			this._tl = null;
		}
		if (this._st) {
			try { this._st.kill(); } catch (e) { }
			this._st = null;
		}
		try { super.destroy(); } catch (e) { }
	}
}
